import { z } from 'zod'
import { Id, LatLon } from './primitives.js'

/**
 * Maps a world's local frame onto the Earth: anchor, rotation about vertical,
 * and uniform scale.
 *
 * Placement is a separate object from the world on purpose. A geo-anchored
 * world simply carries one locked placement, while a portable world can have
 * many owned by different people — which is what lets a drill authored on one
 * football field be dropped onto any other.
 */
export const Placement = z.object({
  id: Id,
  worldId: Id,
  name: z.string().max(120),
  anchor: LatLon,
  anchorAltitudeM: z.number().finite().optional(),
  /** Degrees clockwise from true north applied to the world's +Y (north) axis. */
  rotationDeg: z.number().finite().default(0),
  scale: z.number().finite().positive().default(1),
  /** Geo-anchored worlds lock their placement so consumers cannot move them. */
  locked: z.boolean().default(false),
})
export type Placement = z.infer<typeof Placement>
